<template>
    <section id="OurTeam" class="OurTeam blue-grey lighten-5">
        <div class="row container">
            <div class="col s12 m12 left-text">
                <div class="title center"><img src="/assets/images/ourteam2.png"></div>
            </div>
            <div class="col s12 m12">

                <carousel-3d :controlsVisible="true" :border="0" :space="250" :height="375" :width="250" :perspective="20" :inverseScaling="350" :autoplay="true" :autoplayHoverPause="true" :autoplayTimeout="5000" :clickable="false">
                    <slide v-for="(member, index) in team" :key="index" :index="index">
                        <div class="image">
                            <img class="circle" :src="member.image">
                        </div>
                        <div class="who">
                            <span class="name">{{ member.name }}</span>
                            <span class="role">{{ member.role }}</span>
                        </div>
                    </slide>
                </carousel-3d>
            </div>
        </div>
    </section>
</template>

<script>
import { Carousel3d, Slide } from 'vue-carousel-3d';

export default {
    name: "OurTeam",
    components: {
        Carousel3d,
        Slide
    },
    mounted: function() { 
    },
    data: function() {
        return {
            team: [{
                image: "/assets/images/team/placido_lentini.jpeg",
                role: "Lead Pastor",
                name: "Rev. Placido Lentini"
            },
            {
                image: "/assets/images/team/josephine_wyatt.jpeg",
                role: "Worship Team",
                name: "Josephine Wyatt"
            },
            {
                image: "/assets/images/team/christel_lentini.jpeg",
                role: "Worship Team",
                name: "Christel Lentini"
            },
            {
                image: "/assets/images/team/adriana_lentini.jpg",
                role: "Worship Team",
                name: "Adriana Lentini"
            },
            {
                image: "/assets/images/team/no_profile.jpg",
                role: "Worship Team",
                name: "Alfredo Lentini"
            },
            {
                image: "/assets/images/team/sally_bhandhugravi.jpg",
                role: "Welcome Team",
                name: "Sally Bhandhugravi"
            },
            // {
            //     image: "/assets/images/team/vhia.jpg",
            //     role: "Upkeeping Team",
            //     name: "Vhia"
            // },
            {
                image: "/assets/images/team/lance_bartolotto.jpg",
                role: "Welcome Team",
                name: "Lance Bartolotto"
            },
            {
                image: "/assets/images/team/john_gagliano.jpg",
                role: "Welcome Team",
                name: "John Gagliano"
            },
            {
                image: "/assets/images/team/rachel.jpg",
                role: "Women Ministries Leader",
                name: "Rachel"
            },
            {
                image: "/assets/images/team/no_profile.jpg",
                role: "Fellowship Team",
                name: "Celeste Lentini"
            },
            {
                image: "/assets/images/team/orazio_lentini.jpeg",
                role: "A / V & Tech Team",
                name: "Orazio Lentini"
            },
            {
                image: "/assets/images/team/matthew_wyatt.jpeg",
                role: "A / V & Tech Team",
                name: "Matthew Wyatt"
            }]
        }
    }
};
</script>

<style scoped>
section {
    padding: 4.5rem 3rem 3.5rem 4rem;
}

.carousel {
    height: 525px;
}

.title {
    font-weight: normal;
    font-size: 2.5rem;
    margin-bottom: 1rem;
    letter-spacing: 0.06rem;
}

.image {
    padding-right: 0;
}

.image img {
    max-width: 250px;
    filter: grayscale(100%);
}

.person:hover .image img {
    filter: grayscale(0);
}

.carousel-item.test--active .image img {
    filter: grayscale(0);
    /* max-width: 325px; */
}

.carousel-3d-container {
    height: 325px !important;
}

.carousel-3d-slide {
    /* border: none; */
    text-align: center;
    background: transparent;
}

.carousel-3d-slide:not(.current) .image img {
    opacity: .6;
}

/* .carousel-3d-slide,
.carousel-3d-slide.current {
    height: 325px !important;
} */

.carousel-3d-slide.current .image img {
    filter: grayscale(0);
}

.person {
    text-align: center;
    margin-bottom: 25px;
}

.role {
    display: block;
    font-size: 1rem;
    line-height: 1;
    text-transform: uppercase;
}

.name {
    display: block;
    font-family: 'NewhouseDTCond-ExtBold';
    font-size: 1.75rem;
    line-height: 1.25;
}

p {
    margin-top: 1rem;
    font-size: 1.25rem;
}

@media screen and (max-width: 992px) {
    section {
        padding: 4.5rem 1rem 3.5rem 1rem;
    }
}

</style>